import { render } from "./NewReceptionModal.vue?vue&type=template&id=d0f160be"
import script from "./NewReceptionModal.vue?vue&type=script&lang=js"
export * from "./NewReceptionModal.vue?vue&type=script&lang=js"

import "./NewReceptionModal.vue?vue&type=style&index=0&id=d0f160be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__